















































































































import { Component, Vue } from 'vue-property-decorator'
import Footer from '@/components/Container/Footer.vue'
import CourseUpload from './CourseUpload.vue'
import Exam from './Exam.vue'
import StudyRecord from './StudyRecord.vue'
import FinishRecord from './FinishRecord.vue'
import MinePost from './MinePost.vue'
import EditBasicInfo from './EditBasicInfo.vue'
import { login, getUserInfo } from '@/api/api'

@Component({
  components: {
    Footer,
    CourseUpload,
    Exam,
    StudyRecord,
    FinishRecord,
    MinePost,
    EditBasicInfo
  }
})
export default class PersonalCenter extends Vue {
  userInfo: any = ''
  menuIndex: any = '2'
  isMobile: boolean = false

  created() {
    this.isMobile = window.screen.width < 414
  }

  mounted() {
    this.userInfo = JSON.parse(sessionStorage.userInfo)
    if (this.$route.query.menuIndex) this.menuIndex = this.$route.query.menuIndex
  }

  /**
   * 注销
   */
  logout(): void {
    this.$router.push({ name: 'Login' })
    sessionStorage.clear()
  }

  // 返回个人中心
  returnCenter() {
    this.menuIndex = '2'
  }

  // 编辑资料
  EditBasicInfo() {
    // this.$message.warning('该功能暂未开放')
    this.menuIndex = '0'
  }

  // 选择菜单
  selectMenu(e: any) {
    this.menuIndex = e
    if (e == 1) {
      this.$router.push('/HomePage/Main')
    } else if (e == 6) {
      // this.$message.warning('该功能暂未开放')
      this.$router.push('/TestQuestions')
    }
  }
}
